import type { SearchFilterField } from 'lib-search-types';

import { dateFilterFields } from '../../components/filters/utils/definitions';

/** Checks if the given field is a date field. */
export const isDateFilterField = (
  field: SearchFilterField<'conversations'>,
): field is (typeof dateFilterFields)[number] =>
  dateFilterFields.includes(field as (typeof dateFilterFields)[number]);
